export const globalOnPageChange = (
  page: number,
  setPageFunction: (page: number) => void,
  apiCallFunction: (params: any) => void,
  filters: any
) => {
  setPageFunction(page);
  apiCallFunction({ ...filters, page });
};
